import React from 'react';
;
const JudgemeVerifiedBadge = () => React.createElement("div", { className: "jdgm-widget jdgm-verified-badge-wrapper" });
export default JudgemeVerifiedBadge;
//# sourceMappingURL=JudgemeVerifiedBadge.js.map